import { IProgram } from '../program/interface';

export interface IFetchEmailUtilityAutomationHistoryQuery {
    automationKey: string;
    limit?: number;
    offset?: number;
}

export interface IEmailUtilityAutomationHistory {
    message_id: string;
    automation_key: string;
    status: EmailParseStatus;
    created_events_count: number | null;
    error_message: string | null;
    datetime: string;
}

export interface IEmailUtilityAutomationHistoryContent {
    from: string;
    subject: string;
    html: string;
}

export interface IEmailUtilityAutomation {
    automation_key: string;
    title: string;
    is_active: boolean;
    receiving_from: string[];
    parser_name: string;

    programs: IProgram[];
    history: IEmailUtilityAutomationHistory[];

    date_created: string;
    date_updated: string;
}

export interface IUpdateEmailUtilityAutomation {
    automation_key: string;
    is_active: boolean;
    receiving_from: string[];
}

export enum EmailParseStatus {
    IN_PROGRESS = 'in-progress',
    SUCCESS = 'success',
    FAILED = 'failed',
    IGNORED = 'ignored',
    PARSER_DISABLED = 'parser-disabled',
}

export const EMAIL_PARSE_STATUS_LABEL: Record<EmailParseStatus, string> = {
    [EmailParseStatus.IN_PROGRESS]: 'In Progress',
    [EmailParseStatus.SUCCESS]: 'Success',
    [EmailParseStatus.FAILED]: 'Failed',
    [EmailParseStatus.IGNORED]: 'Ignored',
    [EmailParseStatus.PARSER_DISABLED]: 'Parser Disabled',
};
